import { useQuery } from '@apollo/client';
import { getGlobalComponentList } from "../gqls/useGetGlobalComponentList";
/**
 * 拿取全域元件：廣告元件 !!目前只允許建立一組全域廣告元件
 *
 * @returns {{ globalCarousel: GlobalComponent; }}
 */

var useGetGlobalCarousel = function useGetGlobalCarousel() {
  var _data$getGlobalCompon;

  var _useQuery = useQuery(getGlobalComponentList, {
    variables: {
      input: {
        type: 'CAROUSEL'
      }
    }
  }),
      data = _useQuery.data;

  var globalCarousel = data === null || data === void 0 ? void 0 : (_data$getGlobalCompon = data.getGlobalComponentList) === null || _data$getGlobalCompon === void 0 ? void 0 : _data$getGlobalCompon[0];
  return {
    globalCarousel: globalCarousel
  };
};

export default useGetGlobalCarousel;